<app-exam-report-form [response]="response" (onSubmitCallback)="onSubmit($event[0])"></app-exam-report-form>
